import {
    gql,
  } from "@apollo/client";

export const CREATE_USER = gql`
  mutation CreateUser(
    $fullname: String!
    $username: String!
    $email: String!
    $password: String!
    $role: String!
  ) {
    createUser(
      fullname: $fullname
      username: $username
      email: $email
      password: $password
      role: $role
    ) {
      fullname
      username
      email
      password
      role
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $id: Int
    $fullname: String!
    $username: String!
    $email: String!
    $password: String!
    $role: String!
  ) {
    updateUser(
      id: $id
      fullname: $fullname
      username: $username
      email: $email
      password: $password
      role: $role
    ) {
      id
      fullname
      username
      email
      password
      role
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: Int) {
    deleteUser(id: $id) {
      id
    }
  }
`;

export const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($id: Int, $password: String) {
    updatePassword(id: $id, password: $password) {
      id
      password
    }
  }
`;

export const UPDATE_TASK_WORKER = gql`
  mutation UpdateTaskWorker($id: Int, $status: String) {
    updateTaskWorker(id: $id, status: $status) {
      id
      status
    }
  }
`;

export const CREATE_NOTE_SUPERVISOR = gql`
  mutation CreateNoteSupervisor($project_id: Int, $note: String) {
    createNoteSupervisor(project_id: $project_id, note: $note) {
      project_id
      note
    }
  }
`;

export const UPDATE_TASK = gql`
  mutation UpdateTask(
    $id: Int
    $project_id: Int
    $assignee: Int
    $title: String
    $description: String
    $start_date: String
    $due_date: String
    $attachment: String
    $status: String
  ) {
    updateTask(
      id: $id
      project_id: $project_id
      assignee: $assignee
      title: $title
      description: $description
      start_date: $start_date
      due_date: $due_date
      attachment: $attachment
      status: $status
    ) {
      id
      project_id
      assignee
      title
      description
      start_date
      due_date
      attachment
      status
    }
  }
`;

export const UPDATE_STATUS_PROJECT_SUPERVISOR = gql`
  mutation UpdateStatusProjectSupervisor($id: Int, $status: String) {
    updateStatusProjectSupervisor(id: $id, status: $status) {
      id
      status
    }
  }
`;

export const UPDATE_STATUS_PROJECT_RETURN_PLANNER= gql`
  mutation UpdateStatusReturnSupervisor($id: Int, $note: String) {
    updateStatusReturnSupervisor(id: $id, note: $note) {
      id
    }
  }
`;


export const UPDATE_STATUS_PROJECT_RETURN_WORKER = gql`
  mutation UpdateStatusReturnToWorkerSupervisor($id: Int, $note: String) {
    updateStatusReturnToWorkerSupervisor(id: $id, note: $note) {
      id
    }
  }
`;

export const CREATE_PROJECT_PLANNER = gql`
  mutation CreateProjectPlanner(
    $created_by: Int
  $assignee: [Int]
  $title: String
  $description: String
  $status: String
  $start_date: String
  $due_date: String
) {
  createProjectPlanner(
    created_by: $created_by
    assignee: $assignee
    title: $title
    description: $description
    status: $status
    start_date: $start_date
    due_date: $due_date
  ) {
    created_by {
      id
    }
    assignee {
      id
    }
    title
    description
    status
    start_date
    due_date
  }
}
`;

// export const CREATE_PROJECT_PLANNER = gql`
//   mutation CreateProjectPlanner {
//     createProjectPlanner {
//       created_by
//       assignee
//       title
//       description
//       status
//       start_date
//       due_date
//     }
//   }
// `;

export const UPDATE_PROJECT = gql`
  mutation UpdateProject($title: String, $description: String) {
    createProject(title: $title, description: $description) {
      id
      created_by
      title
      description
      is_complete
    }
  }
`;

export const CREATE_TASK_PLANNER = gql`
  mutation CreateTaskPlanner(
    $project_id: Int
    $task: String
  ) {
    createTaskPlanner(
      project_id: $project_id
      task: $task
    ) {
      project_id
      task
    }
  }
`;
